<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="email-centerbar mb-2">
          <div>
            <h5 class="m-4">
              <i class="bx bx-bell mr-2"></i>
              <span>{{$t("filemanager.notifications.list")}}</span>
            </h5>
            <div class="row">                
              <router-link
                v-for="(notification, index) in pageOfItems"
                :key="index"
                :to="`/notifications/show/${notification.id}`"
                class="notification col-12"
              >  
                <div class="row p-3">
                  <div class="ml-4">
                    <img
                      v-if="notification.picture_small != null"
                      :src="load_image(notification.picture_small)"
                      alt=""
                      style="border-radius: 50%"
                      width="40"
                    />
                    <img
                      v-else
                      src="@/assets/images/users/default.svg"
                      alt=""
                      style="border-radius: 8px"
                      width="40"
                    />
                  </div>
                  <div class="col-10 ml-2">
                    <div class="subject">
                      <h5>{{ notification.title }}</h5>
                    </div>
                    <div class="row">
                      <div class="col">
                        {{ $t('filemanager.notifications.text') }}
                      </div>
                      <div class="date">
                        {{ $d(new Date(notification.created_at), 'short') }}
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="text-center">
              <jw-pagination
                :pageSize="pageSize"
                :items="notifications"
                @changePage="onChangePage"
                :labels="labels"
                class="text-center"
              ></jw-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    Layout,
    // simplebar,
  },
  data() {
    return {
      isLoading: false,

      labels: {
        first: "<<",
        last: ">>",
        next: ">",
        previous: "<",
      },

      bool: false,
      pageOfItems: [],
      pageSize: 10,
      read: {},
      unread: {},
      unreadCount: 0,
    };
  },
  computed: {
    ...mapState({
      notifications: (state) => state.userAuth.notifications,
    }),
  },
  methods: {
    ...mapActions(["userNotifications"]),
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },

    load_image(picture) {
      return process.env.VUE_APP_IMAGE_URL + picture;
    },
    
  },
  created() {
    this.userNotifications();
    this.isLoading = true;
  },
};
</script>

<style>
  .card {
    overflow: hidden;
  }
  .notification {
    color: #4e4e4e;
  }
  .notification:hover {
    background-color: #f3f3f3;
    color: #424242;
  }
  .content {
    border: solid;
    color: gray
  }
</style>
